import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import BiSectionLayout from '../components/biSectionLayout';
import ProtectedRoute from '../components/protectedRoutes';
import AcessosClientesBIAluguel from '../pages/biGE/acessosClientes';
import DashboardAluguel from '../pages/biGE/dashboardAluguel';
import DistratosBIGE from '../pages/biGE/distratos';
import IndicacoesBIGE from '../pages/biGE/indicacoes';
import NpsBIGE from '../pages/biGE/nps';
import TrocasTitularidadeBIGE from '../pages/biGE/trocasTitularidade';

const RouteBIGE = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='BIGE'/>}>
                <Route element={<BiSectionLayout sectionKey='bi-aluguel'/>}>
                    <Route index element={<Navigate to='dashboard' replace/>}/>
                    <Route path='dashboard' element={<DashboardAluguel/>}/>
                    <Route path='acessosClientes' element={<AcessosClientesBIAluguel/>}/>
                    <Route path='distratos' element={<DistratosBIGE/>}/>
                    <Route path='indicacoes' element={<IndicacoesBIGE/>}/>
                    <Route path='nps' element={<NpsBIGE/>}/>
                    <Route path='trocasTitularidade' element={<TrocasTitularidadeBIGE/>}/>
                </Route>
            </Route>
        </Routes>
    );
};

export default RouteBIGE;
